export function homeBannerImage(
  visible: boolean | undefined,
  config: { enabled: boolean; imageUrl: string } | undefined,
  failed: boolean,
  failedImageUrl: string
) {
  const url = config?.imageUrl?.trim() || ''
  return visible === true && config?.enabled === true && !failed && /^https:\/\//i.test(url) && url !== failedImageUrl ? url : ''
}

export function configuredHomeBannerImage(
  banner: { imageUrl?: string } | null | undefined,
  failedImageUrl: string
) {
  const url = banner?.imageUrl?.trim() || ''
  return /^https:\/\//i.test(url) && url !== failedImageUrl ? url : ''
}
